import { GET_SUNGLASSES_BY_SLUG } from "../../operations/queries/operations/queries/get-sunglasses-by-slug.js";
const getSunglassesBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_SUNGLASSES_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getSunglassesBySlug
};
//# sourceMappingURL=getSunglassesBySlug.js.map
